'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagLbAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.87755e-06 0C9.33333 0 18.6667 -8.3689e-05 28 8.88109e-06V20C18.6667 20 9.33333 20 0 20C0 13.3333 -1.21012e-05 6.66667 1.87755e-06 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 5.33333H28V8.88109e-06L1.87755e-06 0L0 5.33333Z",
          fill: "#F03340"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V14.6667H0V20Z",
          fill: "#F03340"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.9428 12.3905C13.1585 12.1748 13.1585 11.8252 12.9428 11.6095L12.8661 11.5328C12.7424 11.409 12.5628 11.3593 12.3931 11.4017L12.0138 11.4965C11.5701 11.6075 11.2948 11.0289 11.6606 10.7545L12.0033 10.4975C12.2158 10.3381 12.1031 10 11.8375 10C11.5458 10 11.453 9.60683 11.7139 9.47639L12.2861 9.19027C12.547 9.05984 12.4542 8.66667 12.1625 8.66667C11.8969 8.66667 11.7842 8.32853 11.9967 8.16916L13.6 6.96667C13.837 6.78889 14.163 6.78889 14.4 6.96667L16.0033 8.16916C16.2158 8.32853 16.1031 8.66667 15.8375 8.66667C15.5458 8.66667 15.453 9.05984 15.7139 9.19027L16.2861 9.47639C16.547 9.60683 16.4542 10 16.1625 10C15.8969 10 15.7842 10.3381 15.9967 10.4975L16.3394 10.7545C16.7052 11.0289 16.4299 11.6075 15.9862 11.4965L15.6069 11.4017C15.4372 11.3593 15.2576 11.409 15.1339 11.5328L15.0572 11.6095C14.8415 11.8252 14.8415 12.1748 15.0572 12.3905C15.4051 12.7384 15.1587 13.3333 14.6667 13.3333H13.3333C12.8413 13.3333 12.5949 12.7384 12.9428 12.3905Z",
          fill: "#1FC065"
        }
      )
    ]
  }
);
const VpFlagLbAsset = forwardRef(FlagLbAsset);

export { VpFlagLbAsset as default };
